import React, { useEffect } from 'react';
import { Checkbox } from '../../areas/app/Checkbox';
import { ScheduledTaskServerRowActionsProps, ScheduledTasksServerRowActions } from './ScheduledTasksServerRowActions';
import ScheduledTasksState from './ScheduledTasksState';
import ScheduledTasksStatus from './ScheduledTasksStatus';
import { ApplicationLastDiscoveredTimestamp } from '../ApplicationServerManagement/ApplicationLastDiscoveredTimestamp';

export interface ScheduledTaskserverRowProps extends ScheduledTaskServerRowActionsProps {
    selected: boolean;
    selectionChangedCallback: Function;
}

export function ScheduledTasksServerRow(props: ScheduledTaskserverRowProps) {
    const [selected, setSelected]: [any, Function] = React.useState(false);

    const serverApp = props.serverApp;
    useEffect(() => {
        setSelected(props.selected);
    }, [props.selected]);

    return (
        <tr>
            <td>
                <Checkbox selected={selected} selectionChangedCallback={(checked: boolean) => props.selectionChangedCallback(checked, serverApp.serverName)} />
            </td>
            <td className="details-link">
                <ApplicationLastDiscoveredTimestamp serverApp={serverApp} />
            </td>
            <td>{serverApp.environment}</td>
            <td>
                <ScheduledTasksState {...serverApp} />
            </td>
            <td>
                <ScheduledTasksStatus {...serverApp} />
            </td>
            <ScheduledTasksServerRowActions {...props}></ScheduledTasksServerRowActions>
        </tr>
    );
}
